import { render } from "./VirtualClassroom.vue?vue&type=template&id=5f8194e0"
import script from "./VirtualClassroom.vue?vue&type=script&lang=js"
export * from "./VirtualClassroom.vue?vue&type=script&lang=js"

import "./VirtualClassroom.vue?vue&type=style&index=0&id=5f8194e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__